import { render, staticRenderFns } from "./ScreenBlocksPreview.vue?vue&type=template&id=311823bf&scoped=true"
import script from "./ScreenBlocksPreview.vue?vue&type=script&lang=js"
export * from "./ScreenBlocksPreview.vue?vue&type=script&lang=js"
import style0 from "./ScreenBlocksPreview.vue?vue&type=style&index=0&id=311823bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311823bf",
  null
  
)

export default component.exports